import React, { useState, useEffect } from 'react';
import apiService from '../../../services/apiService';
import { useParams } from 'react-router-dom';
import Loader from '../../layouts/loader';
import LazyLoad from 'react-lazyload';

const TemplateLibrary = () => {
  const [templateList, setTemplateList] = useState([])
  const [activeFilter, setActiveFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedLang, setSelectedLang] = useState('Select Language');
  const [hasUserInteracted, setHasUserInteracted] = useState(false);
  const [loader, setLoader] = useState(false);
  const { category } = useParams();
  let orgInfo = JSON.parse(localStorage.getItem("orgInfo"));

  useEffect(() => {
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
    const filterCategory = category || (orgInfo?.plan_id === 'plan_1234567890' ? 'policy' : 'All');
    setActiveFilter(filterCategory);
    setHasUserInteracted(false); 
    fetchTemplateList(filterCategory);
  }, [category]);

  const fetchTemplateList = (category) => {
    setLoader(true);
    const token = apiService.getAuthToken();
    const url = category === 'All'
      ? `get-template-list?role=admin`
      : `get-template-list?category=${category}&role=admin`;
    apiService.get(url, token).then(
      (response) => {
        setTemplateList(response?.data);
        setLoader(false);
      },
      (error) => {
        setLoader(false);
        console.error("Error fetching data", error);
      }
    );
  };

  const handleFilterClick = (filter) => {
    setHasUserInteracted(true); 
    setActiveFilter((prevFilter) => {
      if (prevFilter !== filter) {
        fetchTemplateList(filter);
      }
      return filter;
    });
  };

  // Get unique language options from the templates
  const languageOptions = ['Select Language', ...new Set(templateList?.map(t => t?.lang)?.filter(lang => lang != null))];
  // Filter templates by search term and selected language
  const filteredTemplates = templateList?.filter(template =>
    template?.title?.toLowerCase().includes(searchTerm?.toLowerCase()) &&
    (selectedLang === 'Select Language' || template?.lang === selectedLang)
  );

// const downloadFileWithCleanName = async (url) => {
//   try {
//     // Extract the filename from the URL
//     const originalFileName = 'नियुक्ति पत्र.docx';

//     // Remove leading numbers and dash: e.g., "123456-Filename.docx" → "Filename.docx"
//     const cleanedFileName = decodeURIComponent(originalFileName).replace(/^\d+-/, '');

//     console.log('Cleaned File Name:', cleanedFileName);

//     // Fetch the file
//     const response = await fetch(url);
//     const blob = await response.blob();

//     // Create a temporary download link
//     const blobUrl = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = blobUrl;
//     link.download = cleanedFileName;
//     document.body.appendChild(link);
//     link.click();

//     // Cleanup
//     link.remove();
//     window.URL.revokeObjectURL(blobUrl);
//   } catch (err) {
//     console.error('Download failed', err);
//     alert('Failed to download file.');
//   }
// };

  return (
    <div className='page__main'>
      <div className="dashboard" style={{ minHeight: '100vh' }}>
        <div className="container-fuild mb-4">
          <div className="d-flex flex-row justify-content-between align-items-center mb-4">
            <div>
              <h2 className="fw-semibold font-26 mb-2">Template Library</h2>
              <p>Access ready-to-use templates for policies, reports, posters, and more—designed to help you stay compliant with ease.</p>
            </div>
            <div className="col-md-4 d-flex flex-row">
              <select
                className="template-library-select form-select w-50 me-2 position-relative py-1"
                value={selectedLang}
                onChange={(e) => setSelectedLang(e.target.value)}
              >
                {languageOptions?.map(lang => (
                  <option key={lang} value={lang}>
                    {lang?.charAt(0)?.toUpperCase() + lang?.slice(1)}
                  </option>
                ))}

              </select>
              <div className="form-group w-50">
                <input type="text" className="form-control py-2 font-18 mb-0 w-100" placeholder="Search" onChange={e => setSearchTerm(e.target.value)} style={{ Height: '50px !important' }} />
              </div>
            </div>
          </div>
          <div className="row m-0">
            <ul className="nav nav-tabs mb-3 p-0">
              {[
                { label: 'All', key: 'All' },
                { label: 'Policy', key: 'policy' },
                { label: 'Poster', key: 'poster' },
                { label: 'IC Template', key: 'ic_template' },
                { label: 'Email Campaign', key: 'email_campaign' },
                { label: 'Annual Report', key: 'annual_report' },
              ].map((item) => {
                const isAllowed = ['policy', 'poster'].includes(item?.key) || orgInfo?.plan_id !== 'plan_1234567890';
                const isActive = !hasUserInteracted && category ? category === item?.key : activeFilter === item?.key;
                return (
                  <li className="nav-item" key={item?.key}>
                    <button
                      className={`nav-link text-black ${isActive ? 'active' : ''}`}
                      onClick={() => isAllowed && handleFilterClick(item?.key)}
                      disabled={!isAllowed}
                      style={{ opacity: isAllowed ? 1 : 0.5, cursor: isAllowed ? 'pointer' : 'not-allowed' }}
                    >
                      {item.label}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
          {loader ? <Loader /> : <>
          {templateList?.length > 0 ? (
            <div className="template-library row mb-4">
              {filteredTemplates?.map(template => (
                <div key={template?.id} className="col-md-3 col-1280-4">
                  <div className='card shadow-sm p-3 mb-4'>
                    <LazyLoad offset={100}>
                      {template?.thumbnail && <img src={template?.thumbnail} className='template-img w-100' alt="template-img" />}
                      {!template?.thumbnail && <img src='images/template-image.png' className='template-img' alt="template-img" />}
                    </LazyLoad>
                    <h4 className='template-title font-18 my-4 fw-bold'>{template?.title}</h4>
                    <div className='d-flex justify-content-between align-items-center'>
                      <div className='d-flex flex-wrap align-items-center'>
                        <span>
                          {template?.category === 'email_campaign' ? (
                            <span className='badge px-1 rounded-pill text-capitalize me-1' style={{ backgroundColor: 'lightgrey', color: '#191919c7', maxWidth: 'fit-content' }}>Emailer</span>
                          ) : (
                            <span className='badge px-1 rounded-pill text-capitalize me-1' style={{ backgroundColor: 'lightgrey', color: '#191919c7', maxWidth: 'fit-content' }}>{template?.category?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</span>
                          )}
                          {template?.lang
                            ? (
                              <span
                                className='badge px-1 rounded-pill text-capitalize'
                                style={{ backgroundColor: 'lightgrey', color: '#191919c7', maxWidth: 'fit-content' }}
                              >
                                {template?.lang}
                              </span>
                            )
                            : template?.state
                              ? (
                                <span
                                  className='badge px-2 py-1 rounded-pill text-capitalize mt-1'
                                  style={{ backgroundColor: 'lightgrey', color: '#191919c7', maxWidth: 'fit-content' }}
                                >
                                  {template?.state}
                                </span>
                              )
                              : ""}
                        </span>
                      </div>
                      <div className='d-flex flex-wrap align-items-center justify-content-end'>
                        {template?.upload_url?.slice(0, 2)?.map((file, index) => {
                          const isImageFile = file?.type && (
                            file.type.toLowerCase().includes('png') ||
                            file.type.toLowerCase().includes('jpg') ||
                            file.type.toLowerCase().includes('jpeg') ||
                            file.type.toLowerCase().includes('image')
                          );
                          return isImageFile ? (
                            <a
                              key={index}
                              href={file?.url}
                              className='btn btn-primary btn-sm px-1 pt-0 pb-1 mx-1 d-flex align-items-center'
                              target='_blank'
                              rel='noopener noreferrer'
                              download={`${template?.title}-${file?.type}`}
                            >
                              {file?.type}
                              <img
                                src='/images/download.svg'
                                alt='download-icon'
                                width={10}
                                height={10}
                                className='ms-1'
                              />
                            </a>
                            // <button
                            //   key={index}
                            //   onClick={() => downloadFileWithCleanName(file?.url)}
                            //   className='btn btn-primary btn-sm px-1 pt-0 pb-1 mx-1 d-flex align-items-center'
                            // >
                            //   {file?.type}
                            //   <img
                            //     src='/images/download.svg'
                            //     alt='download-icon'
                            //     width={10}
                            //     height={10}
                            //     className='ms-1'
                            //   />
                            // </button>
                          ) : (
                             <a
                              key={index}
                              href={file?.url}
                              className='btn btn-primary btn-sm px-1 pt-0 pb-1 mx-1 d-flex align-items-center'
                              target='_blank'
                              rel='noopener noreferrer'
                              download={`${template?.title}-${file?.type}`}
                            >
                              {file?.type}
                              <img
                                src='/images/download.svg'
                                alt='download-icon'
                                width={10}
                                height={10}
                                className='ms-1'
                              />
                            </a>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p>No templates found.</p>
          )}</>}
        </div>
      </div>
    </div>
  )
}
export default TemplateLibrary;